import DashboardLayout from '../layout/DashboardLayout';
import Login from '../views/Login2';
import Register from '../views/Register';
import ContractDetail from '../views/Contract';

import AllProducts from '../views/products/AllProducts';
import LeasedProducts from '../views/products/LeasedProducts';
import ServiceDetail from '../views/ServiceDetail';

// Single Pages
import Dashboard from '../views/Dashboard';
import Reports from '../views/reports/index';
import Safe from '../views/reports/Safe';

/**
 * Income and Expense
 */
import OrderCreate from '../views/OrderCreate';

import Employees from '../views/employees/Employees';
import CreateEmployee from '../views/employees/CreateEmployee';

import SendSMS from '../views/sms/SendSMS';

import Appointment from '../views/appointments/Appointment';
import AppointmentList from '../views/appointments/AppointmentList';

import Clients from '../views/clients/Clients';
import CreateClient from '../views/clients/CreateClient';
import ShowClient from '../views/clients/ShowClient';

import Definitions from '../views/definitions/index';
import Settings from '../views/settings/index';

/**
 * Super Admin
 */
import Sellers from '../views/system-management/sellers';
import Companies from '../views/system-management/companies';
import CompanyDetail from '../views/system-management/companies/Detail';
import SystemManagement from '../views/system-management/index';
import SuperProducts from '../views/super-products/index';
import SuperProductOrders from '../views/super-products/Orders';
import GeneralExpenses from '../views/reports/GeneralExpenses';
import CoiffeurAppointment from '../views/coiffeurappointments/CoiffeurAppointment';
import CoiffeurAppointmentList from '../views/coiffeurappointments/CoiffeurAppointmentList';
import PastSafe from '../views/reports/PastSafe';
import DeletedProducts from '../views/products/DeletedProducts';
import Announces from '../views/announces/Announces';
import SalesReports from '../views/reports/SalesReports';
import ServiceReports from '../views/reports/ServiceReports';
import IncomeExpensesReport from '../views/reports/IncomeExpensesReport';
import TailorProducts from '../views/products/TailorProducts';
import CreateTailorProduct from '../views/products/CreateTailorProduct';
import DryProducts from '../views/products/DryProducts';
import CreateDryProduct from '../views/products/CreateDryProduct';
import EmployeeReports from '../views/reports/EmployeeReports';
import NewProducts from '../views/products/NewProducts';
import ClientProductsIndex from '../components/ClientProducts/ClientProductsIndex';
import SurplusProducts from '../components/SurplusProducts';
import SureliHizmetler from '../views/SureliHizmetler';
import Credit from '../views/accountings/Credit';

const routes = [
  {
    path: '/giris-yap',
    name: 'login',
    component: Login,
  },
  {
    path: '/kayit-ol',
    name: 'register',
    component: Register,
  },
  {
    path: '/sozlesme/:id',
    name: 'contract',
    component: ContractDetail,
  },
  {
    path: '/',
    name: 'dashboard',
    component: DashboardLayout,
    redirect: '/anasayfa',
    children: [
      {
        path: 'urunler',
        name: 'super-products',
        component: SuperProducts,
        meta: { title: 'Ürün Yönetimi' },
      },
      {
        path: 'urun-siparisleri',
        name: 'super-product-orders',
        component: SuperProductOrders,
        meta: { title: 'Ürün Siparişleri' },
      },
      {
        path: 'anasayfa',
        name: 'home',
        component: Dashboard,
        meta: { title: 'Anasayfa' },
      },
      {
        path: 'hizli-satis',
        name: 'create-order',
        component: OrderCreate,
        meta: { title: 'Hızlı Satış' },
      },
      {
        path: 'cari-islemleri',
        name: 'reports',
        component: Reports,
        meta: { title: 'Cari İşlemleri' },
      },
      {
        path: 'urunler/:id?',
        name: 'serviceQr',
        component: ServiceDetail,
        meta: { title: 'Ürün Detayı' },
      },
      {
        path: 'urun-yonetimi/:type?',
        name: 'services',
        component: AllProducts,
        meta: { title: 'Ürün Yönetimi' },
      },
      {
        path: 'gelecek-urunler',
        name: 'newservices',
        component: NewProducts,
        meta: { title: 'Gelecek Ürünler' },
      },
      {
        path: 'sureli-hizmetler',
        name: 'sureli-hizmetler',
        component: SureliHizmetler,
        meta: { title: 'Gelecek Ürünler' },
      },
      {
        path: 'silinen-urunler',
        name: 'deleted-services',
        component: DeletedProducts,
        meta: { title: 'Silinen Ürünler' },
      },
      {
        path: 'kiralik-urunler/:type?',
        name: 'leased-products',
        component: LeasedProducts,
        meta: { title: 'Kiralık Ürünler' },
      },
      {
        path: 'terzideki-urunler',
        name: 'tailor-products',
        component: TailorProducts,
        meta: { title: 'Terzideki Ürünler' },
      },
      {
        path: 'terziye-urun-gonder',
        name: 'create-tailor-product',
        component: CreateTailorProduct,
        meta: { title: 'Terziye Ürün Gönder' },
      },
      {
        path: 'kurutemizlemedeki-urunler',
        name: 'dry-products',
        component: DryProducts,
        meta: { title: 'Kuru Temizlemedeki Ürünler' },
      },
      {
        path: 'kurutemizlemeye-urun-gonder',
        name: 'create-dry-product',
        component: CreateDryProduct,
        meta: { title: 'Kuru Temizlemeye Ürün Gönder' },
      },
      {
        path: 'calisan-ve-maaslar',
        name: 'employees-and-salaries',
        component: Employees,
        meta: { title: 'Çalışan ve Maaşlar' },
      },
      {
        path: 'calisan-olustur',
        name: 'create-employee',
        component: CreateEmployee,
        meta: { title: 'Çalışan ve Maaşlar' },
      },
      {
        path: 'calisan-duzenle/:id',
        name: 'edit-employee',
        component: CreateEmployee,
        meta: { title: 'Çalışan ve Maaşlar' },
      },
      {
        path: 'kasa',
        name: 'safe',
        component: Safe,
        meta: { title: 'Kasa' },
      },
      {
        path: 'gecmis-kasa/:type?',
        name: 'gecmis-kasa',
        component: PastSafe,
        meta: { title: 'Geçmiş Gün Sonları' },
      },
      {
        path: 'genel-giderler',
        name: 'generalExpenses',
        component: GeneralExpenses,
        meta: { title: 'Genel Giderler' },
      },
      {
        path: 'odeme-al',
        name: 'get-payment',
        component: Dashboard,
        meta: { title: 'Ödeme Al' },
      },
      {
        path: 'randevular',
        name: 'appointments',
        component: Appointment,
        meta: { title: 'Randevular' },
      },
      {
        path: 'randevular-liste/:type?',
        name: 'appointments-list',
        component: AppointmentList,
        meta: { title: 'Randevular' },
      },
      {
        path: 'kuafor-randevular',
        name: 'coiffeur-appointments',
        component: CoiffeurAppointment,
        meta: { title: 'Kuaför Randevuları' },
      },
      {
        path: 'kuafor-randevular-liste/:type?',
        name: 'coiffeur-appointments-list',
        component: CoiffeurAppointmentList,
        meta: { title: 'Kuaför Randevuları' },
      },
      {
        path: 'sms',
        name: 'sms',
        component: SendSMS,
        meta: { title: 'SMS' },
      },
      {
        path: 'musteri-yonetimi',
        name: 'clients',
        component: Clients,
        meta: { title: 'Müşteri Yönetimi' },
      },
      {
        path: 'duyurular',
        name: 'announces',
        component: Announces,
        meta: { title: 'Duyurular' },
      },
      {
        path: 'musteri/:id/urunler',
        name: 'client-products',
        component: ClientProductsIndex,
        meta: { title: 'Müşteri Ürünleri' },
      },
      {
        path: 'musteri-olustur',
        name: 'create-client',
        component: CreateClient,
        meta: { title: 'Müşteri Detayı' },
      },
      {
        path: 'musteri/:id',
        name: 'show-client',
        component: ShowClient,
        meta: { title: 'Müşteri Detayı' },
      },
      {
        path: 'musteri-duzenle/:id',
        name: 'edit-client',
        component: CreateClient,
        meta: { title: 'Müşteri Detayı' },
      },
      {
        path: 'tanimlamalar',
        name: 'definitions',
        component: Definitions,
        meta: { title: 'Tanımlamalar' },
      },
      {
        path: 'ayarlar',
        name: 'settings',
        component: Settings,
        meta: { title: 'Ayarlar' },
      },
      {
        path: 'bayiler',
        name: 'sellers',
        component: Sellers,
        meta: { title: 'Bayiler' },
      },
      {
        path: 'musteriler',
        name: 'companies',
        component: Companies,
        meta: { title: 'Müşteriler' },
      },
      {
        path: 'surplus-products',
        name: 'surplusproducts',
        component: SurplusProducts,
        meta: { title: 'Fazlalık Ürünler' },
      },
      {
        path: 'musteri-detay/:id',
        name: 'company-detail',
        component: CompanyDetail,
        meta: { title: 'Müşteri Detayı' },
      },
      {
        path: 'sales-reports/:type?',
        name: 'sales-reports',
        component: SalesReports,
        meta: { title: 'Satış Raporları' },
      },
      {
        path: 'employee-reports/:type?',
        name: 'employee-reports',
        component: EmployeeReports,
        meta: { title: 'Personel Raporları' },
      },

      {
        path: 'services-reports/:type?',
        name: 'services-reports',
        component: ServiceReports,
        meta: { title: 'Satış Raporları' },
      },

      {
        path: 'gelir-gider-raporlari/:type?',
        name: 'incomeexpenses-reports',
        component: IncomeExpensesReport,
        meta: { title: 'Gelir Gider Raporları' },
      },
      {
        path: 'sistem-yonetimi',
        name: 'system-management',
        component: SystemManagement,
        meta: { title: 'Sistem Yönetimi' },
      },
      {
        path: 'accountings/:id',
        name: 'accountings-credit',
        component: Credit,
        meta: { title: 'Ödemeler' },
      },
    ],
    meta: { requiresAuth: true },
  },
];

export default routes;
